let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("b8lCq")).then(() => parcelRequire('4Ltua'));